export default __webpack_public_path__ + "static/media/33t.e9326e5b.jpg";